import styled from '@emotion/styled';
import React, { Children, useState } from 'react';
import { Reveal } from '../../components/reveal/Reveal';
import { mobileGutterMargin } from '../../styles';
import { device } from '../../styles/devices';
import { typography } from '../../styles/typography';
import { Segment } from '../segment/Segment';

interface IProps {
  children?: any;
  title?: React.ReactNode;
  firstOpen?: boolean;
  singleDisplay?: boolean;
}

const Host = styled(Reveal)`
  margin: ${(props) => `0 -${props.theme.breakpoints.sm.gutter}px`};
  ${mobileGutterMargin}
  @media ${device.tablet} {
    margin: 0;
  }
`;

const Title = styled.h2`
  ${typography.h2}
  flex: 1;

  margin-bottom: 40px;
  margin-left: ${(props) => props.theme.breakpoints.sm.gutter}px;

  @media ${device.tablet} {
    margin-left: 0;
  }
`;

const List = styled.div``;

const Top = styled.div`
  display: flex;
  flex-flow: row wrap;
  align-items: center;
`;

const Categories = styled.div`
  padding-left: ${(props) => `${props.theme.breakpoints.sm.gutter}px`};
  margin-right: ${(props) => `${props.theme.breakpoints.sm.gutter}px`};
  margin-left: auto;
  padding-bottom: ${(props) => props.theme.breakpoints.sm.gutter * 2}px;

  @media ${device.tablet} {
    margin-right: 45px;
    padding-bottom: 40px;
  }
`;

const Category = styled.button<{ active?: boolean }>`
  border-bottom: 1px solid;
  border-bottom-color: ${(props) => (props.active ? '#000' : 'transparent')};
  margin-right: 20px;
  cursor: pointer;

  &:last-child {
    margin-right: 0;
  }
`;

export const AccordionList = ({
  children,
  title,
  firstOpen = false,
  singleDisplay = false,
}: IProps) => {
  const [activeIndexes, setActiveIndexes] = useState(firstOpen ? [0] : []);

  const onOpen = (i: number) => {
    if (singleDisplay) {
      setActiveIndexes([i]);
    } else {
      setActiveIndexes((val) => [...val, i]);
    }
  };

  const onClose = (i: number) => {
    setActiveIndexes((val) => [...val.filter((n) => n !== i)]);
  };

  const childs = Children.toArray(children).map((el: any, index) =>
    React.cloneElement(el, {
      ...el.props,
      index,
      isOpen: activeIndexes.includes(index),
      onOpen,
      onClose,
    }),
  );

  const categories = childs.reduce<string[]>((acc, child: any) => {
    const category =
      /*         Prismic.text(child?.props?.category?.props?.value) || */
      child?.props?.category;

    if (category && typeof category === 'string' && !acc.includes(category)) {
      acc.push(category);
    }
    return acc;
  }, []);

  const [selectedCategory, setSelectedCategory] = useState<string | null>(null);
  const filteredChildren = childs.filter((child: any) => {
    if (child?.props) {
      const category =
        /*         Prismic.text(child?.props?.category?.props?.value) || */
        child?.props?.category;
      if (category === selectedCategory || selectedCategory === null) {
        return true;
      }
      return false;
    }
    return true;
  });

  return (
    <Segment>
      <Host>
        <Top>
          {title && <Title>{title}</Title>}
          {/* Show all button if more than one category and it's string because of storybook */}
          {categories.length > 0 && typeof categories[0] === 'string' && (
            <Categories>
              {
                <Category
                  onClick={() => setSelectedCategory(null)}
                  active={selectedCategory === null}
                >
                  Allt
                </Category>
              }
              {categories.map((category) => {
                return (
                  <Category
                    key={category}
                    onClick={() => setSelectedCategory(category)}
                    active={selectedCategory === category}
                  >
                    {category}
                  </Category>
                );
              })}
            </Categories>
          )}
        </Top>
        <List>{filteredChildren}</List>
      </Host>
    </Segment>
  );
};
